<template>
    <div class="page_">
        <navbar/>
        <div class="breadcrum_">首页 > 理赔流程</div>
        <div class="con_">
          <div class="content" v-html="data">
            
          </div>
        </div>
        <footbar></footbar>
    </div>
</template>
<style lang="scss" scoped>
.page_ {
    font-size: 12px;
    .con_{
      width:1000px;
      margin:20px auto;
      padding:30px;
      display:flex;
      flex-wrap:wrap;
      border-top:1px solid #f2f2f2;
      border-bottom:1px solid #f2f2f2;
      
    }
    .breadcrum_ {
        font-size: 12px;
        color: #666666;
        width:1000px;
        margin: 34px auto 24px;
    }
}
</style>
<script>
import navbar from './components/navbar'
import footbar from './components/footbar'
import api from '@/utils/api'
export default {
    data () {
        document.title = '理赔指引'
        return {
         data:''
        }   
    },
    components: {
        navbar,
        footbar
    },
    mounted () {
       this.fetchData()
    },
    methods: {
      fetchData(){
         api.getCorePcstore().then(res => res.data).then(data => {
              if(data.returnCode === '0000' && data.data!=''){
                  this.data=data.data.claimsProcess
              }
        })
      }
    }
}
</script>